import { TranslatePipe } from '@myre/ui-primitive-core';

import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { RouterLink } from '@angular/router';

import { FooterItem } from '../footer-item.component';

@Component({
  selector: 'myre-footer-url',
  templateUrl: './footer-url.component.html',
  styleUrls: [
    '../../footer-item.component.scss',
    './footer-url.component.scss',
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, TranslatePipe],
})
export class FooterUrlComponent extends FooterItem {
  public get url(): string | string[] {
    return this._url;
  }

  @Input()
  public set url(value: string | string[]) {
    this._url = value;
    this.isExternalUrl = /^https?/.test(
      Array.isArray(value) ? value[0] : value,
    );
  }

  @Input()
  public value: string;

  @Input()
  public target: '_self' | '_blank' | '_parent' | '_top' = '_self';

  public isExternalUrl: boolean = false;

  private _url: string | string[];
}
